import { toFormData } from "@/app/shared/utils/helpers";
import httpManager from "@/app/shared/utils/httpManager";

/**
 * @param {Number} nodeId
 * @param {Object} body
 */

export async function updateNode(nodeId, body) {
  console.log('update node: ', body);
  const bodyTemp = { ...body };
  if (typeof bodyTemp.picture === "string") delete bodyTemp.picture;

  const formData = toFormData(bodyTemp, { avoidEmpty: false, avoidFalse: false });

  await httpManager.put(`/chatbots/nodes/${nodeId}/`, formData);
}
